import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import { useLanguageContext } from "../../../context/LanguageContext";
import { StyledFlexColumn } from "../../../styles/LayoutStyles";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import FormContainer from "../../../components/formContainer/FormContainer";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import Select from "../../../components/select/main/Select";

function BusinessCenterCompanyPageView({
  business_center_company,
  businessCenterCompanyData,
  companies,
  logos,
  terminals,
  onCompanyIdChange,
  onLogoIdChange,
  onTerminalIdChange,
  onCancel,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="business_center_company_page_fetch">
      <FormContainer
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"business_center_company_page_submit"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.company_id")}
            error={EVAApiHelper.getResponseError("company_id", submitError)}
            required={true}
          >
            <Select
              value={businessCenterCompanyData.company_id}
              disabled={business_center_company}
              options={companies.map((company) => ({
                value: company.id,
                label: company.name,
              }))}
              onChange={onCompanyIdChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.logo_id")}
            error={EVAApiHelper.getResponseError("logo_id", submitError)}
            required={false}
          >
            <Select
              value={businessCenterCompanyData.logo_id}
              options={logos.map((logo) => ({
                value: logo.id,
                label: logo.name,
              }))}
              onChange={onLogoIdChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.terminal_id")}
            error={EVAApiHelper.getResponseError("terminal_id", submitError)}
            required={false}
          >
            <Select
              value={businessCenterCompanyData.terminal_id}
              options={terminals
                .filter(
                  (terminal) =>
                    parseInt(terminal.company) ===
                    parseInt(businessCenterCompanyData.company_id)
                )
                .map((terminal) => ({
                  value: terminal.id,
                  label: terminal.name,
                }))}
              onChange={onTerminalIdChange}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default BusinessCenterCompanyPageView;
